import { render, staticRenderFns } from "./CrossSellModal.vue?vue&type=template&id=c97a1248&scoped=true"
import script from "./CrossSellModal.vue?vue&type=script&lang=ts"
export * from "./CrossSellModal.vue?vue&type=script&lang=ts"
import style0 from "./CrossSellModal.vue?vue&type=style&index=0&id=c97a1248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97a1248",
  null
  
)

export default component.exports